import "../loginPage/LoginPage.scss";

import pwcLogo from "@appkit4/styles/images/PwC_logo_new.svg";
import { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../../contexts/useAuth";
import { AppRoutes } from "../../types/enums/appRoutes";
import { LoginLabel, LogoutLabel } from "../../types/enums/labels";

/**
 * Full-screen sign-out screen. Renders outside the app shell. On mount it ends
 * the Entra session via a redirect; the user lands back on the login screen
 * once Entra completes the sign-out. Authentication only — no roles.
 */
function LogoutPage() {
  const { isAuthenticated, logout } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    void logout().catch((err: unknown) => {
      setError(err instanceof Error ? err.message : String(err));
    });
  }, [logout]);

  // Already signed out (e.g. direct navigation) and the redirect did nothing —
  // send the user to the login screen.
  if (!isAuthenticated && !error) {
    return <Navigate to={AppRoutes.login} replace />;
  }

  return (
    <div className="login-page">
      <header className="login-page__top">
        <img
          className="login-page__logo"
          src={pwcLogo}
          alt={LoginLabel.PwcLogoAlt}
        />
      </header>

      <main className="login-page__main">
        <div className="login-page__card">
          {error ? (
            <div className="login-page__error" role="alert">
              <strong>{LogoutLabel.SignOutFailed}</strong> {error}
            </div>
          ) : (
            <>
              <h1 className="login-page__product">{LogoutLabel.SigningOut}</h1>
              <p className="login-page__welcome" role="status" aria-live="polite">
                {LogoutLabel.Wait}
              </p>
            </>
          )}
        </div>
      </main>
    </div>
  );
}

export default LogoutPage;
